import bnc from "bnc";

export const block = new bnc("ui-schema-auth-form");
